import { BaseLogicExpression } from "./BaseLogic";
import { ExpressionValue } from "../../ExpressionValue";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { BooleanDataDefinition } from "../../../Common/Data/Definitions/BooleanDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class NotExpression extends BaseLogicExpression {
    readonly __type: string = "Not";
    value1: ExpressionValue;

    constructor() {
        super();
        this.value1 = ExpressionValue.createExpressionValue(this, "value1", new BooleanDataDefinition());
        this.expressionValueType = new BooleanDataDefinition();
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return !this.value1.evaluate(data, testContext);
    }
}
